module.exports = __webpack_public_path__ + "static/media/starts_with_oe.e4decd38.mp3";